import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getPickupAddresses,
  postPickupAddress,
  deletePickupAddress,
  updatePickupAddress,
  clearErrors,
} from "../../redux/Actions/pickupAddressAction";
import { getCountries } from "../../redux/Actions/countryAction";
import PickupAddressEditModal from "./Items/PickupAddressEditModal";
import ContentBlock from "../Layout/ContentBlock";
import Pagination from "../Dashboard/items/Pagination";
import TableColumnPickupAddress from "./Items/TableColumnPickupAddress";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import InputText from "../orders/accepted_orders/InputFilter";
import SelectInput from "../common/SelectInput";

class PickupAddresses extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      page: 1,
      pageCount: 100,
      action: "new",
      filters: {
        title: "",
        label_sizes: "",
      },
      paramsFilter: "",
    };
  }
  componentDidMount() {
    this.props.getPickupAddresses(
      this.state.page,
      this.state.pageCount,
      this.state.paramsFilter
    );
    this.props.getCountries(1, 500);
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getPickupAddresses(
        this.state.page,
        this.state.pageCount,
        this.state.paramsFilter
      );
    }
  }

  onAction = (action, index) => {
    this.setState({
      requiredId: index,
      action: action,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  onFilter = () => {
    let filterParams = [];
    if (this.state.filters.title?.length > 0) {
      filterParams.push(
        `&q[code_or_address_cont_any]=${this.state.filters.title}`
      );

      let filter_title = this.state.filters.title.split(" ");
      filter_title.forEach((item) => {
        filterParams.push(`&q[code_or_address_cont_any]=${item}`);
      });
    }

    const label_sizes = this.state.filters.label_sizes;
    if (label_sizes) {
      if (label_sizes == "not_seleceted") {
        filterParams.push("&q[label_sizes_raw_blank]=1");
      } else {
        filterParams.push(`&q[label_sizes_raw_cont]=${label_sizes}`);
      }
    }

    this.setState(
      {
        paramsFilter: filterParams.join(""),
        page: 1,
      },
      () =>
        this.props.getPickupAddresses(
          this.state.page,
          this.state.pageCount,
          filterParams.join("")
        )
    );
  };

  render() {
    console.log("t1");
    const requiredItem = this.state.requiredId;
    let modalData = this.props.pickupAddressesItems[requiredItem]
      ? this.props.pickupAddressesItems[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Pickup addresses",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            totals={this.props.totals}
            length={this.props.pickupAddressesItems.length}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text2="Pickup addresses"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox
            filter={false}
            add={this.onAction}
            clearFilter={() =>
              this.setState({
                filters: {
                  title: "",
                },
              })
            }
          >
            <div className="px-1">
              <InputText
                style={{ width: 150, fontSize: "0.75rem" }}
                number="1"
                name="title"
                placeholder="Pavadinimas"
                value={this.state.filters.title}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    this.onFilter();
                  }
                }}
                onChange={(e) =>
                  this.setState({
                    filters: {
                      ...this.state.filters,
                      title: e.target.value,
                    },
                  })
                }
              />
            </div>
            <div className="col-3">
              <SelectInput
                options={[
                  {
                    label: "All",
                    value: "",
                  },
                  {
                    label: "A4",
                    value: "A4",
                  },
                  {
                    label: "A5",
                    value: "A5",
                  },
                  {
                    label: "A6",
                    value: "A6",
                  },
                  {
                    label: "Not selected",
                    value: "not_seleceted",
                  },
                ]}
                label={"Label sizes"}
                value={this.state.filters.label_sizes}
                onChange={(label_sizes) => {
                  this.setState(
                    {
                      filters: {
                        ...this.state.filters,
                        label_sizes,
                      },
                    },
                    () => this.onFilter()
                  );
                }}
              />
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_pickupAddress}
              array={this.props.pickupAddressesItems}
              alertId_s="pickupAlert-s"
              alertId_e="pickupAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">#</th>
                      <th className="text-black">Code</th>
                      <th className="text-black">Company</th>
                      <th className="text-black">Contact person</th>
                      <th className="text-black">Adress</th>
                      <th className="text-black">City</th>
                      <th className="text-black">Country</th>
                      <th className="text-black">Postal code</th>
                      <th className="text-black">Phone number</th>
                      <th className="text-black">Work time</th>
                      <th className="text-black">E.mail</th>
                      <th className="text-black">Active?</th>
                      <th className="text-black">Comments</th>
                      <th className="text-black">Label sizes</th>
                      <th className="text-black">Auto shipment email</th>
                      <th className="text-black">Technorama</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.pickupAddressesItems.map((item, index) => {
                      return (
                        <TableColumnPickupAddress
                          key={index}
                          index={index}
                          item={item}
                          onEdit={this.onAction}
                          onDelete={this.props.deletePickupAddress}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <Pagination
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        <PickupAddressEditModal
          action={this.state.action}
          postPickupAddress={this.props.postPickupAddress}
          updatePickupAddress={this.props.updatePickupAddress}
          objectData={modalData}
          clearErrors={this.props.clearErrors}
          countries={this.props.countries || []}
          errors={this.props.errors}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  pickupAddressesItems: state.pickupAddress.pickupAddresses,
  totals: state.pickupAddress.totals,
  loading_pickupAddress: state.pickupAddress.loading_pickupAddress,
  countries: state.country.countries,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getPickupAddresses,
  postPickupAddress,
  deletePickupAddress,
  updatePickupAddress,
  getCountries,
  clearErrors,
})(PickupAddresses);
